import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-add-product-master-group',
  templateUrl: './add-product-master-group.component.html',
  styleUrls: ['./add-product-master-group.component.css']
})
export class AddProductMasterGroupComponent implements OnInit {

  form: any | FormGroup
  cid:any
  formSubmit: boolean = false;

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.form = this.fb.group({
      name: ['',[Validators.required]],
      description:['']
    })

  }

  addProductMasterGroup(){
    this.formSubmit = true;
    if(!this.form.valid){
      return
    }
    let body = {
      "version": 0,
      "isActive": true,
      "description": this.form.get('description').value,
      "id": "",
      "productMasterGroupId": 0,
      "name": this.form.get('name').value,
      "cid": this.cid,
    }

    this.generic_service.addProductMasterGroup(body).subscribe(
      (response:any)=>{
        this.formSubmit = false;
        this.form.reset()
        this.toastr.success(response.message);
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }



}